export default __webpack_public_path__ + "static/media/otherIconEmpty.daadf4d3.svg";